export const NO_BUTTON_ELEMENT_HREF =
    'Button does not have the href attribute configured, it is required!';
